import { render, staticRenderFns } from "./RemainingLabel.vue?vue&type=template&id=9b3b90cc&scoped=true&lang=pug&"
import script from "./RemainingLabel.vue?vue&type=script&lang=js&"
export * from "./RemainingLabel.vue?vue&type=script&lang=js&"
import style0 from "./RemainingLabel.vue?vue&type=style&index=0&id=9b3b90cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b3b90cc",
  null
  
)

export default component.exports